var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"mt-10",attrs:{"row":"","fluid":""}},_vm._l((_vm.resources),function(resource,index){return _c('tile-item',{key:index,staticClass:"mr-10",attrs:{"resource":resource}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }